







































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NewComponent extends Vue {
  @Prop() wp!: number;
  @Prop() hp!: number;
  readonly w = this.wp * 10;
  readonly h = this.hp * 10 * 1.5;
  get styleObj() {
    return {
      position: "absolute",
      width: `${this.wp}%`,
      height: `${this.hp}%`,
    };
  }
}
